import styled from "styled-components";

export const Header = styled.div`
    h1{
        color: #002e5c;
        font-size: 20px;
        font-weight: bolder; 
    }
    span{
        font-size: 15px;
        color: #b5b5c3;  
    }
`
export const Wrapper = styled.div`
    

`
export const CheckBoxWrapper = styled.ul`
list-style-type: none;
li{
    font-size: 16px;
    color: #002e5c;
}
`

export const CreditCardMethodContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
export const CreditCardMethodHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    @media only screen and (max-width: 380px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;
export const CreditCardMethodTitle = styled.div`
    color: #3f4255;
    font-size: 16px;
    font-weight: 700;
`;

export const CreditCardMethodContent = styled.div`
`

export const CreditCardMethodList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;

`;

export const CreditCardMethodButton = styled.button`
    border: none;
    background: transparent;
    padding: 0;
`;

export const CreditCardMethodItem = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 14px;

    p {
        display: flex;
        gap: 14px;
        align-items: center;
        font-size: 14px;
        margin: 0 !important;
    }

    span > div, span label {
        margin: 0 !important;
    }
`;

export const CreditCardMethodItemVerify = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;


export const CreditCardMethodItemVerifyInput = styled.input`
    width: 40px;
    height: 32px;
    border: 0.9px solid gray;
    text-align: center;
    border-radius: 5px;
`;
